import state from './moduleSkillsState'
import mutations from './moduleSkillsMutations'
import actions from './moduleSkillsActions'
import getters from './moduleSkillsGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}